!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("draft-js"), require("@campfire/comment-field"), require("@material-ui/core")) : "function" == typeof define && define.amd ? define(["exports", "react", "draft-js", "@campfire/comment-field", "@material-ui/core"], t) : t((e = e || self)["saveable-comment-field"] = {}, e.React, e.draftJs, e.commentField, e.core);
}(this, function (e, t, n, r, o) {
  "use strict";

  var a = "default" in t ? t.default : t;
  e.SaveableCommentField = function (e) {
    var i = e.rawContent,
        c = e.onSave,
        f = e.setUnsavedComments,
        u = t.useState(n.EditorState.createEmpty()),
        d = u[0],
        m = u[1],
        s = t.useState(n.EditorState.createEmpty()),
        l = s[0],
        v = s[1];
    return t.useEffect(function () {
      var e;

      try {
        if (i) {
          e = n.convertFromRaw(JSON.parse(i));
          var t = n.EditorState.createWithContent(e);
          m(t), v(t);
        }
      } catch (e) {
        throw new Error("Invalid rawContent provided to CommentField");
      }
    }, [i]), t.useEffect(function () {
      var e = l ? n.convertToRaw(l.getCurrentContent()).blocks[0].text : void 0,
          t = d ? n.convertToRaw(d.getCurrentContent()).blocks[0].text : void 0;
      f && f(e !== t);
    }, [d]), a.createElement(r.CommentField, {
      initialState: l,
      editorState: d,
      setEditorState: m
    }, function (e) {
      var t = e.unfocusEditor,
          r = e.setHasChanges;
      return a.createElement(a.Fragment, null, a.createElement(o.Button, {
        style: {
          textTransform: "none"
        },
        onClick: function onClick() {
          t();
        }
      }, "Discard"), a.createElement(o.Button, {
        style: {
          textTransform: "none"
        },
        color: "primary",
        variant: "contained",
        onClick: function onClick() {
          c(JSON.stringify(n.convertToRaw(d.getCurrentContent()))), v(d), r(!1);
        }
      }, "Save"));
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});